import type { RouteRecordRaw } from 'vue-router';

export const WAREHOUSE_ROUTER: RouteRecordRaw[] = [
  {
    path: '/warehouse',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/warehouse/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/master/warehouse/views/List.vue'),
        name: 'Warehouse List',
        meta: {
          title: '창고 마스터',
        },
      },
      {
        path: 'create',
        component: () => import('@/modules/master/warehouse/views/Detail.vue'),
        name: 'Warehouse Create',
        meta: {
          title: '창고 등록',
        },
      },
    ],
  },
  {
    path: '/warehouse/detail/:no',
    component: () => import('@/modules/master/warehouse/views/Detail.vue'),
    name: 'Warehouse Detail',
    meta: {
      title: '창고 상세',
      requiresAuth: true,
    },
  },
];
